import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navbar = _resolveComponent("navbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_DemoManager = _resolveComponent("DemoManager")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_navbar),
    _createVNode(_component_router_view),
    (_ctx.showDemoManager)
      ? (_openBlock(), _createBlock(_component_DemoManager, { key: _ctx.demoManagerKey }))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer)
  ], 64))
}